module.exports = __webpack_public_path__ + "static/img/GQ.301132d3.svg";